<!--
 * @Author: chenx
 * @Descripttion:
 * @Date: 2021-12-09 10:04:38
 * @LastEditors: chenx
 * @LastEditTime: 2022-03-10 17:25:29
-->
<template>
    <div class="hotTender">
        <div class="tc-10"></div>
        <FilterSearch
          v-if="filterSearchLoad"
          v-model="filterSearchData" 
          :initNumber="7" 
          :defaultForm="defForm" 
          :mapModeNotField="mapModeNotField"
          :currentPosition="addressObj"
          @searchChange="searchChange" 
          @getCurPosition="myPoint"
        />
        <div class="search-wapper" :class="{ mapFull: mapBoxShow }">
            <FullPositionMode 
              v-if="mapBoxShow" 
              :currentPosition="addressObj"
              @fullScreen="fullScreen" 
              @clickCurrentPoint="myPoint"
            />
            <LeaseList
                v-if="isShowCardList !== 'MAP'"
                :formData="formData"
            ></LeaseList>
            <MapList
                v-if="isShowCardList === 'MAP'"
                :propsObj="propsObj"
                :formData="formDataMap"
                :positionAddress="positionAddress"
                @fullScreen="fullScreen"
                :mapBoxShow="mapBoxShow"
            ></MapList>
        </div>

        <el-dialog
            class="map-dialog"
            :visible.sync="mapVisible"
            width="1200px"
            :before-close="() => (mapVisible = false)"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <MapAddress
                v-if="mapVisible"
                :positionAddress="positionAddress"
                :type="1"
                @close="() => (mapVisible = false)"
                @setPosition="getPosition"
            />
        </el-dialog>
    </div>
</template>
<script>
import tenderCommonApi from '@/api/zhaocai/tenderCommonApi/index'
import http from '@/http/zhaocai'
import cookie from '@/storage/cookies.js'
import { getDefaltType } from '@/components/zhaocai/FilterSearch/template/constant.js'
import apiUser from "@/public/apiUser/apiUser"
export default {
  name: 'hotTender',
  components: {
    SelectionSort: () => import('./components/NewSelectionSort'),
    LeaseList: () => import('./components/NewLeaseList'),
    MapList: () => import('@/views/hotTender/components/mapList'),
    SearchBar: () => import('@/components/public/SearchBar'),
    MapAddress: () => import('@/components/map/ResMapAddress'),
    FullPositionMode: () => import('@/components/zhaocai/FilterSearch/components/fullPositionMode.vue'),
    FilterSearch: () => import('@/components/zhaocai/FilterSearch/index.vue')
  },
  data () {
    return {
      datas:[],
      // 不需要单独获取清单的类型6-地质勘察 7-设计/规划 8-专业监理 9-造价服务 10-工程总包 13-PPP项目
      notOrderTypeEnum: [6, 7, 8, 9, 10, 13],
      filterSearchLoad: false,
      // 默认form数据配置
      defForm: {
        tenderMothed: '',
        showMode: 'CARD',
        page: 1,
        limit: 20
      },
      mapModeNotField: ['sortMethod','dataSources', 'province', 'city'],
      dynamicEnum: {}, // 招标方式动态列表枚举
      // 筛选菜单配置
      filterSearchData: [
        {
          field: 'type',
          label: '招标类型',
          name: 'TagList',
          defaultValue: '',
          options: [],
          childField: [],
          isInitShow: true
        },
        {
          field: 'tenderMothed',
          label: '招标方式',
          name: 'TagList',
          childField: ['dynamicField', 'price', 'qualificationWay', 'applyEndTime', 'biddingMethod', 'sortMethod', 'dataSources'],
          resetDefvalueField: { // 重制，不添加默认值的状态
            dycField: 'province',
            isNotSetDefaultVal: [2, 3]
          },
          isInitShow: true,
          defaultValue: '',
          options: [],
        },
        {
          field: 'dynamicField',
          label: '招标方式子集动态字段',
          name: 'TagList',
          defaultValue: '',
          options: [],
        },
        {
          field: 'province',
          label: '省份',
          name: 'TagList',
          defaultValue: '',
          options: [],
          childField: ['city'],
          isInitShow: true
        },
        {
          field: 'city',
          label: '所在地',
          name: 'TagList',
          defaultValue: '',
          options: [],
        },
        {
          label: '更多筛选',
          name: 'Select',
          isFormList: true,
          options: [
            { 
              name: 'Select',
              options: [],
              placeholder: '请选择报名截止时间',
              defaultValue: '',
              field: 'applyEndTime',
              isHide: true,
              style: { width: '180px' }
            },
            {
              name: 'Select',
              options: [],
              placeholder: '请选择招标方式',
              defaultValue: '',
              field: 'biddingMethod',
              isHide: true,
              style: { width: '180px' }
            },
            {
              options: [],
              placeholder: '请选择资格审查方式',
              defaultValue: '',
              field: 'qualificationWay',
              isHide: true,
              style: { width: '180px' }
            },
            {
              options: [],
              isHide: false,
              placeholder: '请选择预算金额范围',
              defaultValue: '',
              field: 'price',
              isInitShow: true,
              style: { width: '180px' }
            }
          ]
        },
        {
          isTableList: true,
          // name: 'TableList',
          options: [
            {
              field: 'sortMethod',
              label: '',
              name: 'SortList',
              defaultValue: 1,
              options: [],
              notCondition: true  // 不触发筛选条件
            },
            {
              field: 'dataSources',
              label: '',
              name: 'Checkbox',
              defaultValue: [1, 2],
              options: [],
              notCondition: true
            },
          ],
        },
        {
          field: 'keyword',
          label: '',
          name: 'BtnInput',
          defaultValue: '',
          options: [],
          showSearchMode: ['CARD','TABLE','MAP'], // 哪几种模式下展示搜索框
          style: {
            width: '340px'
          },
          isInitShow: true,
          isForm: true,
          notCondition: true
        }
      ],
      // 列表参数参数
      isShowCardList: '',
      formData: {},
      formDataMap: {},

      typeStr: 'zbatAll',
      propsObj: {},
      searchData: {},
      islist: false, // 是否为列表
      searchForm: {
        keyword: '',
        mapDistance: ''
      },
      isShowSearch: true,
      typeLists: {
        listShow: true, // 地区
        tenderTypeShow: true, // 招标类型
        priceListShow: false, // 预算金额
        tenderStatusShow: false, // 招标状态
        timeListShow: false, // 报名结束时间
        biddingMethodShow: false, // 招标方式
        tenderFromShow: false, // 招标形式
        moreShow: true, // 筛选更多
        projeCateShow: false,
        demandFromShow: false, // 需求预告-需求类型
        engineerTypeShow: false, // 需求预告-工程类型
        creatTimeShow: false // 需求预告-发布时间
      },
      cardMode: true, // 显示模式，true为卡片模式，false为列表模式
      listMode: false,
      map: true,
      mapIcon: true,
      mapVisible: false,
      mapAMap: {},
      positionAddress: {},
      mapBoxShow: false,
      tabPosition: '1',
      sortRuleArr: [],
      addressObj: {
        address: '',
        lng: 116.418481,
        lat: 39.90833
      },
      geocoder: null,
      demandFormNo: 1,
      categoryId: '',
      engineerNo: '',
      creatTime: '',
      area: '',
      city: '',
      tags: 0,
      changeDemand: 0,
      position: null,
    }
  },
  created () {
    this.initSearchOptions()
  },
  mounted () {
    this.initType()
    this.GaodeMap()
    //获取所有省
    apiUser.getArea().then(res => {
      if (res.data.code === 200) {
        this.datas=res.data.data
      } 
    })
  },
  watch: {

    tabPosition: {
      handler: function (val) {
        this.$set(this.propsObj, 'sortMethod', val)
        this.propsObj = JSON.parse(JSON.stringify(this.propsObj))
      },
      immediate: true
    },
    dataSources(val) {
      // 数据来源：0.全部 1.经营帮 2.政府网站 3.全都不选
      const len = val.length
      this.propsObj.dataSourceShow.no = len ? (len === 1 ? val[0] : 0) : 3
    }
  },
  // 方法
  methods: {
    // 递归计算树形数据最大的层级数
    calculationLevel(arr) {
      let maxLevel = 0
      !function multiArr(arr, level) {
          ++level
          maxLevel = Math.max(level, maxLevel);
          for (let i = 0; i < arr.length; i++) {
              let item = arr[i]
              item.level = level
              if (item.child && item.child.length > 0) {
                  multiArr(item.child, level)
              } else {
                  delete item.child
              }
          }
      }(arr, 0)
      return maxLevel
    },
    // 筛选菜单更改触发
    searchChange({ data, form }) {
      // 22-工厂租赁只展示一级，不用设置树结构
      // data && form[form.oldTypeField] != 22 && (data.child || data.children) && !data.isOldType && this.setTypeChildrenOpts(data, form) // 处理带children子集数据
      data && data.isOldType && !this.notOrderTypeEnum.includes(+data.val) && this.setTypeChild(data) // 如果是原来20种类型的，请求清单数据并设置
      // 22-工厂租赁只展示一级，不用设置树结构
      if(data && form[form.oldTypeField] != 22 && (data.child || data.children)) {
        if(!data.isOldType) {
          this.setTypeChildrenOpts(data, form)
        } else {
          this.notOrderTypeEnum.includes(+data.val) && this.setTypeChildrenOpts(data, form)
        }
      }
      data && data.field === 'province' && this.setCityList(data)
      data && data.field === 'tenderMothed' && this.setDynamicField(data, form)
      // 根据类型动态设置招标方式
      if(!data || ['type', 'type_1'].includes(data.field)) {
        this.setTenderMothed(data)
      }
      this.formatFormData(data, form)
    },
    // 格式化接口参数
    formatFormData(data, form) {
      const arr = []
      const obj = {}
      const { showMode, tenderMothed } = form
      this.isShowCardList = showMode
      const dycFieldEnum = {
        1: 'state',
        2: 'price',
        3: 'applyStartTime'
      }
      if(showMode !== 'MAP') {
         // 3.招采大厅-不限 4.招采大厅--招标公告 8.招采大厅--动态竞 13.招采大厅-招标预告 20.招采大厅-需求预算
        const positionEnum = {'': 3, 1: 4, 2: 8, 3: 13, 4: 20}
        Object.entries(form).map(([key, val]) => {
          if(key.includes('goodsTypeNo')) {
            val && arr.push(val)
          } else if (key === 'dataSources') {
            // 数据来源：0.全部 1.经营帮 2.政府网站 3.全都不选
            const len = val.length
            obj[key] = len ? (len === 1 ? val[0] : 0) : 3
          } else if (key === 'tenderMothed') {
            // 招标方式-字段转换
            // obj['queryPosition'] = positionEnum[val]
            obj['queryPosition'] = 23//不限筛选下只显示工程分包和劳务分包的数据
          } else if (key.includes('type')) {
            if(val) {
              obj['typeNos'] = val
              // if(form['oldTypeField'] === key) {
              //   obj['type'] = val
              // } else {
              //   obj['typeNos'] = val
              // }
            }
          } else {
            key !== 'oldTypeField' && key !== 'dynamicField' && (obj[key] = val)
          }
        })
        obj['goodsType'] = arr.join(',')
        obj['goodsTypeNo'] = arr.join(',')

        if(obj.goodsTypeNo) { // 存在清单，带入原本20种类型赋值type入参
          obj['type'] = obj.typeNos || ''
        }
        if(tenderMothed) {
          obj[`${dycFieldEnum[tenderMothed]}`] = form.dynamicField
        } else {
          // obj['state'] = ''
          // obj['price'] = ''
          // obj['applyStartTime'] = ''
        }
        if(obj.goodsTypeNo) { // 存在清单，带入原本20种类型赋值type入参
          obj['type'] = obj.typeNos || ''
        }
        this.formData = { ...obj, typeNos: obj.typeNos || '' }
      } else {
        Object.entries(form).map(([key, val]) => {
          if(key.includes('goodsTypeNo')) {
            val && arr.push(val)
          } else if (key.includes('type')) {
            if(val) {
              obj['typeNos'] = val
              // if(form['oldTypeField'] === key) {
              //   obj['type'] = val
              // } else {
              //   obj['typeNos'] = val
              // }
            }
          }
        })
        if(tenderMothed) {
          obj[`${dycFieldEnum[tenderMothed]}`] = form.dynamicField
        } else {
          obj['state'] = ''
          obj['price'] = ''
          obj['applyStartTime'] = ''
        }
        if(arr.length) { // 存在清单，带入原本20种类型赋值type入参
          obj['type'] = obj.typeNos || ''
        }
        obj['areacode'] = form.province
        obj['city'] = form.city
        obj['biddingMethod'] = form.biddingMethod
        obj['distance'] = form['keyword'] || 1000
        obj['goodsType'] = arr.join(',')
        obj['limit'] = form.limit
        obj['page'] = form.page
        obj['latitude'] = this.addressObj.lat
        obj['longitude'] = this.addressObj.lng
        obj['time'] = form.applyEndTime
        obj['qualificationWay'] = form.qualificationWay
        this.formDataMap = { ...obj, type: obj.type || ''}
      }
    },
    // 根据类设置招标方式
    async setTenderMothed(data) {
      let type = data ? data.val ? data.isOldType ? data.type: 0 : 0 : 0
      // if(data && data.isOldType || data && !data.val) {
        const res = await tenderCommonApi.getTenderWay(type) // 招标方式
        if(res.data.code !== 0) {
          this.$message.warning(res.data.msg)
          return
        }
        const list = [ {no: '', name: '不限'}, ...res.data.result ]
        this.filterSearchData.map(item => {
          if(item.isFormList || item.isTableList) { // form表单list
            
          } else { // tag列表
            if(item.field === 'tenderMothed') {
              item.options = list
            }
          }
        })
      // }
    },
    // 动态设置招采方式下的子集关联内容
    setDynamicField(data, form) {
      const labelEnum = {
        1: '招标状态',
        2: '预算金额',
        3: '报名开始时间'
      }
      const listEnum = { // 根据值枚举获取列表
        1: 'state',
        2: 'price',
        3: 'applyStartTime'
      }
      const {childField, val, resetDefvalueField = undefined} = data
      let searchData = JSON.parse(JSON.stringify(this.filterSearchData))
      this.filterSearchData = searchData.map(x => {
        if(x && !x.isFormList) {
          if(x.isTableList) {
            // table排序筛选条件
            const sortFieldEnum = {
              '': 'sortMethod',
              1: 'sortMethod',
              2: 'bidSort',
              3: 'advanceSort'
            }
            const list = this.dynamicEnum[sortFieldEnum[val]]
            const tableList = x.options.map(item => {
              if(item.name === 'SortList') {
                return {
                  ...item,
                  options:list ? [...list] : []
                }
              } else {
                // 动态竞价-2 招标预告-3 需求预算-4 不展示数据来源
                const showDataSourceEnum = [2,3,4]
                if(showDataSourceEnum.includes(+val)) {
                  return {
                    ...item,
                    options: []
                  }
                }
                return {
                  ...item,
                  options: this.dynamicEnum['dataSources']
                }
              }
            })
            return {
              ...x,
              options: tableList
            }
          } else {
            // tag筛选条件
            const curfield = childField[0]
            if(x.field === curfield) {
              return {
                ...x,
                label: labelEnum[val],
                options: this.dynamicEnum[listEnum[val]]
              }
            } else {
              // 处理招标公告-不限-需求预算 所在地动态展示
              if(resetDefvalueField && x.field == 'city') {
                if(!resetDefvalueField.isNotSetDefaultVal.includes(+val)) { 
                  return {
                    ...x,
                    options: this.dynamicEnum['city']
                  }
                } else {
                  return x
                }
              } else {
                return x
              }
            }
          }
        } else { // form表单筛选
          const dycField = {
            '': ['price'],
            1: ['price', 'qualificationWay', 'applyEndTime', 'biddingMethod'],
            2: [],
            3: ['price', 'qualificationWay'],
            4: []
          }
          const fields = dycField[val]
          const list = x && x.options.map(item => {
            if(fields && fields.length) {
              return {
                ...item,
                isHide: !fields.includes(item.field)
              }
            } else {
              return {
                ...item,
                isHide: true
              }
            }
          })
          return {
            ...x,
            options: list
          }
        }
      })      
    },
    async setCityList(data) {
      const { childField = [] } = data
      if(childField && childField.length) {
        const currentIndex = this.filterSearchData.findIndex(x => x.field === childField[0])
        this.filterSearchData[currentIndex].options = await this.getCitysList(data)
      } 
    },
    // 设置存在child | children的子集
    setTypeChildrenOpts(data, form) {
      const { field, childField = [] , child = [], children = [], typeLevel } = data
      const childs = child.length ? child : children
      if(childField && childField.length) {
        const currentIndex = this.filterSearchData.findIndex(x => x.field === childField[0])
        if(childs && childs.length) {
          const arr = childs.map(x => ({
            ...x,
            name: x.name || x.categoryName,
            no: x.no || x.id
          }))
          this.filterSearchData[currentIndex].options = [{name: '不限', no: ''}, ...arr]
          this.filterSearchData[currentIndex].label = data.name
        } else {
          this.filterSearchData[currentIndex].options = []
        }
      } 
    },
    // 初始化招标类型子集集合
    async initTypeChild(tree) {
      const level = this.calculationLevel(tree)
      const allChild = [] // 所有子集
      for(let i = 1; i <= level; i++) {
        allChild.push(`type_${i}`)
      }
      for(let i = level+1; i <= level+3; i++) { // 清单数据初始化默认3级
        allChild.push(`goodsTypeNo_${i}`)
      }
      // 递归获取所有子集
      function init(arr, resArr, level) {
        if(!arr.length) {
            return resArr
        }
        const o = { name: 'TagList', field: '', label: '', childField: [], options: [], defaultValue: '',  typeLevel: level}
        o.field = arr[0]
        o.childField = arr.filter(x => x !== o.field)
        resArr.push(o)
        return init(o.childField,resArr, level)
      }
      const childArr = init(allChild, [], level)
      const arr = childArr.map(x => {
        if(x.field.includes('type')) {
          return {
            ...x,
            childField: [...x.childField, 'tenderMothed', 'dynamicField']
          }
        } else {
          return x
        }
      })
      // 父级别添加所有子集
      const currentIndex = this.filterSearchData.findIndex(x => x.field === 'type')
      this.filterSearchData[currentIndex].childField = allChild
      this.filterSearchData[currentIndex].typeLevel = level
      // 寻找第一项子集
      const childIndex = this.filterSearchData.findIndex(x => x.field === allChild[0])
      if(childIndex !== -1) {
        // 子集存在-替换第一个child
        this.filterSearchData.splice(currentIndex+1, 1, childArr[0])
      } else {
        // 子集不存在-添加所有子集
        this.filterSearchData.splice(currentIndex+1, 0, ...childArr)
      }
    },
    // 搜索条件初始化数据
    async initSearchOptions() { 
      this.filterSearchLoad = false
      const typeReq = await tenderCommonApi.getTenderTypeTree({businessScenario: ''}) // 招标类型
      // const typeReq = await tenderCommonApi.getTenderType() // 招标类型
      if(typeReq.data.code !== 0) {
        return this.$message.warning(typeReq.data.msg)
      }
      await this.initTypeChild(typeReq.data.result) // 初始化招标类型所有子集
      // 初始化api数据获取
      const provinceList = this.getProvince() // 省列表
      const wayReq = tenderCommonApi.getTenderWay(0) // 招标方式
      const stateReq = tenderCommonApi.getTenderState() // 招标状态
      const offterendReq = tenderCommonApi.getTenderTimeOptions() // 报名开始时间
      const moneyReq = tenderCommonApi.getMoneySelectOptions() // 金额范围
      const verticalTypeReq = tenderCommonApi.getTenderWayOptions() // 资格审查方式
      const getCitys = tenderCommonApi.getCitys({ areacode: provinceList[1].id}) // 市列表
      const getDataSource = tenderCommonApi.getDataSourcesOptions() // 数据来源
      const getTenderMethodOptions = tenderCommonApi.getTenderMethodOptions() // 招标方式
      const getSortAll = tenderCommonApi.getSortAll() // 招标公告|招标大厅-招采方式-不限 列表排序
      const getSortAdvance = tenderCommonApi.getSortPrenotice() // 招标预告列表排序
      const getSortBid = tenderCommonApi.getSortDysincBid() // 动态竞价列表排序
      Promise.all([wayReq, stateReq, getCitys, moneyReq, getDataSource,getSortAll,verticalTypeReq,offterendReq, getTenderMethodOptions, getSortAdvance, getSortBid]).then(res => {
        const typeRes = typeReq.data // 招标类型
        const wayRes = res[0].data // 招标方式
        const stateRes = res[1].data // 招标状态
        const cityRes = res[2].data // 市列表
        const moneyRes = res[3].data // 金额范围
        const sourceRes = res[4].data // 数据来源
        const sortRes = res[5].data // 列表时间排序 - 招标公告 招采方式-不限
        const verticalTypeRes = res[6].data // 资格审查方式
        const offterendRes = res[7].data // 报名截止时间
        const tendermethodRes = res[8].data // 招标方式
        const advanceSort = res[9].data // 招标预告列表排序
        const bidSort = res[10].data // 动态竞价列表排序
        if (advanceSort.code !== 0) {
          this.$message.error(advanceSort.msg)
          return
        }
        if (bidSort.code !== 0) {
          this.$message.error(bidSort.msg)
          return
        }
        if (typeRes.code !== 0) {
          this.$message.error(typeRes.msg)
          return
        }
        if (wayRes.code !== 0) {
          this.$message.error(wayRes.msg)
          return
        }
        if (stateRes.code !== 0) {
          this.$message.error(stateRes.msg)
          return
        }
        if (cityRes.code !== 0) {
          this.$message.error(cityRes.msg)
          return
        }
        if (moneyRes.code !== 0) {
          this.$message.error(moneyRes.msg)
          return
        }
        if (sourceRes.code !== 0) {
          this.$message.error(sourceRes.msg)
          return
        }
        if (sortRes.code !== 0) {
          this.$message.error(sortRes.msg)
          return
        }
        if (verticalTypeRes.code !== 0) {
          this.$message.error(verticalTypeRes.msg)
          return
        }
        if (offterendRes.code !== 0) {
          this.$message.error(offterendRes.msg)
          return
        }
        if (tendermethodRes.code !== 0) {
          this.$message.error(tendermethodRes.msg)
          return
        }
        const noFilter = { name: '不限', no: '' }
        const priceAreaList = moneyRes.result.filter(x => x.name !== '全部')
        const sourceList = sourceRes.result.filter(x => x.name !== '全部')
        const stateList = stateRes.result.filter(x => x.name !== '全部')
        const endTimeList = offterendRes.result.filter(x => x.name !== '全部')
        const tenderMethodList = tendermethodRes.result.filter(x => x.name !== '全部')
        this.dynamicEnum['state'] = [noFilter, ...stateList] // 招标状态
        this.dynamicEnum['price'] = [noFilter, ...priceAreaList], // 概算金额
        this.dynamicEnum['applyStartTime'] = [noFilter, ...endTimeList] // 招标开始时间
        this.dynamicEnum['sortMethod'] = [...sortRes.result] // 招标公告和不限列表排序
        this.dynamicEnum['advanceSort'] = [...advanceSort.result] // 招标预告列表排序
        this.dynamicEnum['bidSort'] = [...bidSort.result] // 动态竞价列表排序
        this.dynamicEnum['province'] = provinceList // 省份列表
        this.dynamicEnum['city'] = [noFilter, ...cityRes.result.list] // 所在地
        this.dynamicEnum['dataSources'] = [...sourceList] // 数据来源
        const arr=typeRes.result.filter(x => x.id === '1620700546166034432')[0].child.filter(x => x.id == '1620703325886484480'||x.id == '1620706012346585088')
        const resOpts = {
          'province': provinceList, // 省份
          'type': [noFilter, ...arr], // 招标类型
          'tenderMothed': [noFilter, ...wayRes.result], // 招标方式
          'city': [noFilter, ...cityRes.result.list], // 所在地
          // 'applyStartTime': [noFilter, ...endTimeList], // 招标开始时间
          'dataSources': [...sourceList], // 数据来源
          'sortMethod': [...sortRes.result], // 排序规则
          'price': [{ name: '不限', no:'-1'}, ...priceAreaList], // 下拉框概算金额
          'qualificationWay': [{ name: '不限', no:'-1'}, ...verticalTypeRes.result],
          'applyEndTime': [{ name: '不限', no:'-1'}, ...endTimeList],
          'biddingMethod': [{ name: '不限', no:'-1'}, ...tenderMethodList],
        }
        this.setSearchOptions(resOpts)
      })
    },
    // 通过招标类型-初始化子清单数据
    async setTypeChild(data) {
      const { val, typeLevel } = data
      const reqEnum = {
        1: 'ov1/mechanicalLabor/findOnlyMachineryCategoryList', // 机械租赁
        2: 'ov1/mechanicalLabor/findTeamCategoryAllList', // 劳务分包
        3: 'ov1/mechanicalLabor/findItemCatAllList', // 商品材料
        4: 'ov1/mechanicalLabor/findTeamCategoryAllList', // 工程分包
        5: 'ov1/mechanicalLabor/findOnlyEquipmentCategoryList', // 设备租赁
        6: 'ov1/tender/type/getTenderType/2', // 地质勘察
        7: 'ov1/tender/type/getTenderType/1', // 设计规划
        8: 'ov1/tender/type/getTenderType/2', // 专业监理
        9: 'ov1/tender/type/getTenderType/2', // 造价咨询
        10: 'ov1/tender/type/getTenderType/2', // 工程总包
        11: `${process.env.VUE_APP_APIEQUIPMENT}/real/category/listCategory?type=0`, // 房产租赁
        12: 'ov1/mechanicalLabor/findCarTypeList', // 车辆租赁
        13: 'ov1/tender/type/getTenderType/2', // PPP项目
        14: '', // 土地产权转让
        15: `${process.env.VUE_APP_APIEQUIPMENT}/real/category/listCategory?type=0`, // 房产转让
        16: 'ov1/mechanicalLabor/findOnlyMachineryCategoryList', // 机械转让
        17: 'ov1/mechanicalLabor/findOnlyEquipmentCategoryList', // 设备转让
        18: 'ov1/mechanicalLabor/findCarTypeList', // 车辆转让
        19: `${process.env.VUE_APP_LOGISTICS}/goodsType/findCarLenList`, // 物流货运
        // 19: `${process.env.VUE_APP_LOGISTICS}/goodsType/carTypeByGoodsType?GoodsTypeNo=${val}`, // 物流货运
        20: '', // 其他
        21: `${process.env.VUE_APP_APIEQUIPMENT}/land/landleaseCategory/getAll`,
        22: `${process.env.VUE_APP_APIEQUIPMENT}/factory/category/getFactoryCategorySelect`,
        23: `${process.env.VUE_APP_APIEQUIPMENT}/farmMachinery/category/getFactoryCategorySelect`,
      }
      const reqUrl = reqEnum[val]
      let arr = []
      if(!reqUrl) {
        if(+val === 14) {
          arr = await getDefaltType(val)
        }
      } else {
        const res = await http.get(reqUrl)
        const { code, msg, result, data:result1 } = res.data
        if(code !== 0 && code !== 200) {
          this.$message.error(msg)
          return
        }
        arr = result && result.length ? result : result1.map(x => 
          ({
            ...x,
            name: x.name || x.categoryName,
            no: x.no || x.id
          })
        )
      }
      const labelEnum = {
        1: '机械分类', // 机械租赁
        2: '工程分类', // 劳务分包
        3: '商品分类', // 商品材料
        4: '工程分类', // 工程分包
        5: '设备分类', // 设备租赁
        6: '工程分类', // 地质勘察
        7: '工程分类', // 设计规划
        8: '工程分类', // 专业监理
        9: '工程分类', // 造价咨询
        10: '工程分类', // 工程总包
        11: '房产类型', // 房产租赁
        12: '车型', // 车辆租赁
        13: '工程分类', // PPP项目 
        14: '土地用途', // 土地产权转让
        15: '房产类型', // 房产转让
        16: '机械分类', // 机械转让
        17: '设备分类', // 设备转让
        18: '车型', // 车辆转让
        19: '货物类型', // 物流货运
        20: '', // 其他
        21: '土地分类',
        22: '工厂分类',
        23: '农机分类',
      }
      const resData = [{ name: '不限', no: '' }, ...arr]
      let searchData = JSON.parse(JSON.stringify(this.filterSearchData))
      this.filterSearchData = searchData.map(x => {
        if(x.field === data.childField[typeLevel] && !x.isTableList && !x.isFormList) {
          return {
            ...x,
            options: arr.length ? resData : [],
            label: labelEnum[val]
          }
        } else {
          return x
        }
      })
    },
    // 设置搜索框
    setSearchOptions(data) {
      this.filterSearchData.map(item => {
        if(item.isFormList || item.isTableList) { // form表单list
          item.options.map(x => {
            x.options = data[x.field]
          })
        } else { // 其他
          if(Object.keys(data).includes(item.field)) {
            item.options = data[item.field]
            if(item.field === 'province') {
              item.defaultValue = data[item.field][1].no
            } else {
            }
          } else {

          }
        }
      })
      this.filterSearchLoad = true
    },
    // 初始化省列表
    getProvince () {
      let currentArea ={} // 当前定位地址
      if(cookie.cookieRead('area')){
        currentArea = JSON.parse(cookie.cookieRead('area'))
      }else{
        currentArea={
          areaName: "四川省",
          checked: true,
          id: 510000,
          lat: "30.659462",
          level: 1,
          lng: "104.065735",
          shortName: "四川"
        }
      }
      // const provinceList = JSON.parse(localStorage.getItem('areaAll')) // 全省
      const provinceList = JSON.parse(localStorage.getItem('areaAll'))||this.datas // 全省
      const { areaName, id } = currentArea
      let list = []
      if(areaName === '北京') {
        list = [
          { areaName: '全国', id: '', shortName: '全国' },
          ...provinceList
        ]
      } else {
        const arr = provinceList.filter(x => x.id !== id)
        list = [
          { areaName: '全国', id: '', shortName: '全国' },
          { ...currentArea },
          ...arr
        ]
      }
      return list.map(x => {
        return {
          ...x,
          name: x.shortName,
          no: x.id
        }
      })
    },
    // 获取市列表
    async getCitysList(data) {
      const { val } = data
      if (!val) return [] // 如果是全国不展示市所在地
      const params = {
        areacode: val
      }
      const res = await tenderCommonApi.getCitys(params)
      if(res.data.code !== 0) {
        this.$message.error(res.data.msg)
        return
      }
      return [{ name: '不限', no: '' }, ...res.data.result.list]
    },
    // -------搜索条件选项重构代码------------end
    // 招标形式点击
    tenderFromChange (item) {
      this.typeLists = this.$options.data().typeLists
      this.tabPosition = '1'
      this.typeLists.tenderFromShow = true // 招标形式
      this.isShowSearch = true
      this.map = true
      if (item.name === '动态竞价') {
        // 动态竞价
        this.typeStr = 'direct-jb'
        this.map = true // 展示地图内容
        this.cardMode = true
        this.listMode = false
        this.typeLists.moreShow = false
        this.typeLists.timeListShow = false
        this.typeLists.priceListShow = true
        this.typeLists.typeLabel = '竞价类型'
        this.typeLists.timeLabel = '发布时间'
        this.getDirectBidSort()
      } else if (item.name === '招标公告') {
        this.typeStr = 'zb'
        this.map = true // 展示地图内容
        this.cardMode = true
        this.listMode = false
        this.typeLists.moreShow = true
        this.typeLists.tenderStatusShow = true
        this.typeLists.tenderFromShow = true // 招标形式
        this.allSort()
      } else if (item.name === '招标预告') {
        this.typeStr = 'notice'
        this.typeLists.moreShow = true
        this.typeLists.timeStartListShow = true
        this.typeLists.tenderFromShow = true // 招标形式
        this.typeLists.isNoEndTime = true // 无截止时间
        this.preNoticeSort()
      } else if (item.name === '需求预算') {
        this.isShowSearch = false
        this.typeStr = 'demand'
        this.typeLists.demandFromShow = true
        this.typeLists.engineerTypeShow = false
        this.typeLists.creatTimeShow = false
        this.typeLists.tenderTypeShow = false
        this.typeLists.moreShow = false
        this.changeDemand++
      } else {
        // 招标大厅不限
        this.typeStr = 'zbatAll'
        this.map = true
        this.cardMode = true
        this.listMode = false
        this.isShowSearch = true
        this.allSort()
      }
    },
    // 清空筛选调取列表接口
    getDemandList () {
      this.engineerNo = ''
      this.creatTime = ''
      this.area = ''
      this.city = ''
      this.categoryId = ''
    },
    // 商品分类筛选条件
    projeCateChange (item) {
      this.categoryId = item.no
    },
    // 商品分类筛选条件
    OneprojeCateChange (item) {
      this.categoryId = item.no
    },
    // 商品分类筛选条件
    TwoprojeCateChange (item) {
      this.categoryId = item.no
    },
    // 需求类型筛选条件
    demandFormChange (item) {
      this.demandFormNo = item.no
      this.getDemandList()
      if (item.no === 1 || item.no === 2 || item.no === 3) {
        this.typeLists.engineerTypeShow = false
      } else {
        this.typeLists.engineerTypeShow = true
      }
    },
    // 工程类型筛选条件
    engineerChange (item) {
      this.engineerNo = item.no
    },
    // 发布时间筛选条件
    creatTimeChange (item) {
      this.creatTime = item.no
    },
    // 地区更改
    areaChange (item) {
      if (item.id !== '') {
        this.area = item.id.toString()
      } else {
        this.area = ''
      }
    },
    cityChange (item) {
      this.city = item.id
    },
    initType () {
      this.tabPosition = '1'
      switch (this.$route.path) {
        case '/zb':
          this.typeStr = 'zbatAll'
          this.isShowSearch = true
          this.typeLists.tenderStatusShow = false // 招标状态
          this.typeLists.tenderFromShow = true // 招标形式
          break
        default:
          break
      }
    },

    // 招标公告tab排序规则
    allSort () {
      tenderCommonApi.getTenderingSortSelectTab().then(res => {
        if (res.data.code === 0) {
          this.sortRuleArr = res.data.result
        }
      })
    },
    // 招标公告tab排序规则
    noticeSort () {
      tenderCommonApi.tenderNoticeSort().then(res => {
        if (res.data.code === 0) {
          this.sortRuleArr = res.data.result
        }
      })
    },
    // 招标预告tab排序规则
    preNoticeSort () {
      tenderCommonApi.tenderPreNoticeSort().then(res => {
        if (res.data.code === 0) {
          this.sortRuleArr = res.data.result
        }
      })
    },
    // 直接竞价tab排序规则
    getDirectBidSort () {
      tenderCommonApi.newDirectBidSort().then(res => {
        if (res.data.code === 0) {
          this.sortRuleArr = res.data.result
        }
      })
    },
    aa (paload) {
      if (paload.clear === 'all') {
        this.cardMode = true
        this.listMode = false
      }

      // if (this.$route.query.type) {
      //   if (!paload.screenList.tenderTypeShow.no) {
      //     return
      //   }
      // }
      // 数据来源：0.全部 1.经营帮 2.政府网站 3.全都不选
      const len = this.dataSources.length
      paload.screenList.dataSourceShow.no = len ? (len === 1 ? this.dataSources[0] : 0) : 3
      this.propsObj = paload.screenList
      this.propsObj.searchData = { searchName: '' }
      // 进页面发送新请求处理
      if (
        (this.propsObj.tenderTypeShow.name === '' ||
          this.propsObj.tenderTypeShow.name === '不限') &&
        this.propsObj.tenderTypeShow.no === ''
      ) {
        this.propsObj.default = 'newQuestion'
      } else if (this.propsObj.tenderTypeShow.no === '') {
        this.propsObj.default = 'oldQuestion'
      } else {
        this.propsObj.default = 'newQuestion'
      }
      
    },
    onSearch (val) {
      this.$set(this.propsObj, 'searchData', this.searchForm)
      this.propsObj = JSON.parse(JSON.stringify(this.propsObj))
    },
    tabhandle (val) {
      switch (val) {
        case 1:
          this.cardMode = true
          this.listMode = false
          this.map = true
          break
        case 2:
          this.cardMode = true
          this.listMode = false
          this.map = true
          break
        case 3:
          this.cardMode = false
          this.listMode = true
          this.map = true
          break
        case 4:
          this.cardMode = false
          this.listMode = true
          this.map = true
          break
        case 5:
          this.cardMode = false
          this.listMode = false
          this.map = false
          break
        default:
          break
      }
    },
    myPoint () {
      this.mapVisible = true
    },
    getPosition (obj, center) {
      this.positionAddress = obj
    },
    fullScreen () {
      this.mapBoxShow = !this.mapBoxShow
    },
    // 初始化高德地图
    GaodeMap () {
      var that = this
      this.position = JSON.parse(localStorage.getItem('position'))
      if(!this.position) {
        setTimeout(() => {
          this.GaodeMap()
        },3000)
        return
      }
      this.mapAMap = new AMap.Map('containerMap', {
        resizeEnable: true,
        showIndoorMap: false, // 关闭室内地图
        zoom: 12
      })
      that.icon = new AMap.Icon({
        size: new AMap.Size(32, 42), // 图标尺寸
        image: require('../../assets/map-point.png'), // Icon的图像
        imageOffset: new AMap.Pixel(2, 2), // 图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new AMap.Size(15, 17) // 根据所设置的大小拉伸或压缩图片
      })
      AMap.plugin('AMap.Geocoder', function () {
        that.geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        })
      })
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', // 定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true, // 定位成功后是否自动调整地图视野到定位点
          showButton: false,
          markerOptions: {
            // 自定义定位点样式，同Marker的Options
            offset: new AMap.Pixel(-18, -36),
            content: '<img src="https://a.amap.com/jsapi_demos/static/resource/img/user.png" style="width:36px;height:36px"/>'
          },
          circleOptions: {
            // 定位精度圈的样式
            strokeColor: '#0093FF',
            noSelect: true,
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: '#02B0FF',
            fillOpacity: 0.25
          }
        })
        that.mapAMap.addControl(geolocation)
        if (that.position && that.position.lng && that.position.lat) {
          that.addressObj.lng = that.position.lng
          that.addressObj.lat = that.position.lat
          that.regeoCode()
        } else {
          geolocation.getCurrentPosition(function (status, result) {
            if (status == 'complete') {
              // 获得成功
              that.mapAMap.setZoomAndCenter(12, [
                result.position.lng,
                result.position.lat
              ])
              that.cityName = result.addressComponent.city
                ? result.addressComponent.city.slice(
                  0,
                  result.addressComponent.city.length - 1
                )
                : ''
              that.addressObj.lng = result.position.lng
              that.addressObj.lat = result.position.lat
              that.regeoCode()
            } else {
              // 获得失败
              console.log('定位失败')
            }
          })
        }
      })
      this.mapAMap.on('click', function (e) {
        that.addressObj.lng = e.lnglat.lng
        that.addressObj.lat = e.lnglat.lat
      })
    },
    // 查询地址
    regeoCode () {
      var that = this
      this.geocoder.getAddress(
        [that.addressObj.lng, that.addressObj.lat],
        function (status, result) {
          if (status === 'complete' && result.regeocode) {
            that.addressObj.address = result.regeocode.formattedAddress
          } else {
            that.$message.error('根据经纬度查询地址失败')
          }
        }
      )
    }
  }

}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.Engineering_menu__box {
  width: 100%;
  background: #f5f5f5;
}
.sortRadio:nth-child(1) {
  /deep/ .el-radio-button__inner {
  padding-left: 0;
}
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff !important;
  border: none;
  color: #e40e1b !important;
  box-shadow: none;
  border-left: 1px solid #ccc;
}
/deep/.el-radio-button__inner {
  border: none;
  border-left: 1px solid #ccc;
}
/deep/ .el-radio-button:first-child .el-radio-button__inner {
  border: none !important;
}
/deep/ .el-radio-button__inner:hover {
  color: #e40e1b !important;
}
/deep/ .el-radio-button__inner {
  padding: 5px 20px;
}
</style>
<style lang="scss">
.hotTender {
  .tc-20 {
    height: 20px;
  }
  .btns {
    line-height: 40px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    margin-left: 15px;
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
      vertical-align: sub;
    }
    .map-img {
      width: 30px;
      height: 26px;
    }
    .brclass {
      display: inline-block;
      width: 1px;
      height: 24px;
      background: rgba(228, 231, 237, 1);
      margin: 0 20px;
    }
  }
}
.cursor {
  vertical-align: middle;
}
/deep/ .el-input-group__append,
/deep/ .el-input-group__prepend {
  background-color: #ffffff;
}
.mapFull {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999999;
}
.model_search_input {
  width: 350px !important;
  .el-input__inner {
    border-radius: 0 !important;
    height: 30px !important;;
  }
}
.model_search_btn {
  border-radius: 0 !important;
  background-color: #e40e1b !important;
  border-color: #e40e1b !important;
  margin-left: 10px !important;
  width: 54px;
  height: 30px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>
